import { isProductionEnvironment } from '../app-env';
import { readEnvVariable } from '../helpers';

export interface ITurnstileEnv {
  siteKey: string;
}

const TURNSTILE_TEST_SITE_KEY = '1x00000000000000000000AA';
const TURNSTILE_PROD_SITE_KEY = '0x4AAAAAAER2-hP2t7ei_qDk';

export function getTurnstileEnv(): ITurnstileEnv {
  const siteKey = readEnvVariable('NEXT_PUBLIC_TURNSTILE_SITE_KEY');
  return {
    siteKey:
      siteKey || (isProductionEnvironment() ? TURNSTILE_PROD_SITE_KEY : TURNSTILE_TEST_SITE_KEY),
  };
}
